import { PaginationData } from 'shared/types';
import { productRequester as request } from './requesters';
import { ProductTypeRegul } from '../models';

const productTypeRegulService = {
    getProductTypeRegul: (params: any) => request.get<PaginationData<ProductTypeRegul>>(`/product-type-reguls`, { params }),
    getOneProductTypeRegul: (id: number) => request.get<ProductTypeRegul>(`/product-type-reguls/${id}`),
    createProductTypeRegul: (input: any) => request.post('/product-type-reguls', input),
    updateProductTypeRegul: (id: number, input: any) => request.put(`/product-type-reguls/${id}`, input),
    deleteProductTypeRegul: (id: number) => request.delete(`/product-type-reguls/${id}`)
};

export default productTypeRegulService;